import { render, staticRenderFns } from "./VendeurStatusLabel.vue?vue&type=template&id=e84988d6&scoped=true&"
import script from "./VendeurStatusLabel.vue?vue&type=script&lang=ts&"
export * from "./VendeurStatusLabel.vue?vue&type=script&lang=ts&"
import style0 from "./VendeurStatusLabel.vue?vue&type=style&index=0&id=e84988d6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e84988d6",
  null
  
)

export default component.exports